import { useLocation, useParams, useHistory } from 'react-router-dom';
import { parse, stringify } from 'query-string';
import { useMemo } from 'react';

export function useRouter() {
    const location = useLocation();
    const params = useParams<any>();
    const history = useHistory();
    const query = useMemo<any>(() => parse(location.search), [location]);

    function replaceParams(path, object = {}, query?: any) {
        const $params = { ...params, ...object };

        let replaced = path?.route || path || '';

        const result = Object.keys($params || {}).reduce(
            (replaced = '', key) => replaced.replace(`:${key}`, $params?.[key] || key),
            replaced,
        );

        if (query) {
            return [result, stringify(query)].join('?');
        } else {
            return result;
        }
    }

    return {
        location,
        query,
        params,
        history,
        goBack: history.goBack,
        push(routeOrPage, params?, query?) {
            const targetPath = replaceParams(routeOrPage.route || routeOrPage, params, query);

            if (targetPath.startsWith('http')) {
                window.location.href = targetPath;
            } else {
                history.push(targetPath);
            }
        },
        isPathActive(path: string) {
            return location.pathname.startsWith(path);
        },
        replaceParams,
    };
}
